































import { Prop, Component, Vue } from "vue-property-decorator";

import { FolderEntry, Breadcrumb } from "@/models/file";

import VFolder from "@/components/file/VFolder.vue";
import VFolderPath from "@/components/file/VFolderPath.vue";
import VFolderEntry from "@/components/file/VFolderEntry.vue";
import VMark from "./VMark.vue";

@Component({
  components: {
    VMark,
    VFolder,
    VFolderPath,
    VFolderEntry
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  }
})
export default class VReportSelectModal extends Vue {
  @Prop({ default: () => [] }) entries!: FolderEntry[];
  @Prop({ default: () => [] }) breadcrumbs!: Breadcrumb[];

  selectedEntries: FolderEntry[] = [];

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  init() {
    this.selectedEntries = [];
  }

  ok() {
    this.$emit("ok", this.selectedEntries);
    this.hide();
  }

  upload(files: File[]) {
    this.$emit("upload", files);
  }

  open(entry: FolderEntry): void {
    if (entry.kind === "folder") {
      this.$emit("cd", entry.entryId);
    } else {
      if (this.$props.multiple) {
        this.toggle(entry);
      } else {
        this.selectedEntries = [entry];
      }
    }
  }

  toggle(entry: FolderEntry) {
    const i = this.selectedEntries.findIndex(
      e => String(e.entryId) === String(entry.entryId)
    );
    if (i < 0) {
      this.selectedEntries.push(entry);
    } else {
      this.selectedEntries.splice(i, 1);
    }
  }

  openPath(breadcrumb: Breadcrumb): void {
    this.$emit("cd", breadcrumb.id);
  }

  isSelected(entry: FolderEntry) {
    return this.selectedEntries.some(
      e => String(e.entryId) === String(entry.entryId)
    );
  }
}
